var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('aside',{staticClass:"nopath"},[_c('p',{staticClass:"nopath__text"},[_vm._v(_vm._s(_vm.$t('pageNotFound')))]),_c('router-link',{staticClass:"nopath__button",attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.$t('homepage')))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }